import { render, staticRenderFns } from "./ProductSalesPageFAQItem.vue?vue&type=template&id=308d21e2&scoped=true&"
import script from "./ProductSalesPageFAQItem.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageFAQItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSalesPageFAQItem.vue?vue&type=style&index=0&id=308d21e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d21e2",
  null
  
)

export default component.exports